<script>
import {ImagePreview} from 'vant';
export default {
  data() {
    return {
      // 列表数据
      page1:1,//当前页
      size1:10,//每页条数
      totals1:0,//总条数
      totalPages1:0,//总页数
      finished1: true,
      loading1:false,
      finishedMsgTxt:'没有更多了',
      inList:[],
    };
  },

  watch:{
    // 监控参数变化更新游戏列表接口数据
    searchParams:function() {
      this.getListData();
    },
  },
  computed:{
    // 监控参数变化更新游戏列表接口数据
    searchParams() {
      return {
        pageSize:this.size1,//每页数量
        pageNum:this.page1,//当前页码
        orderByColumn:'startTime',
        isAsc:'desc',
      };
    },
  },
  methods: {
    // 字符串内过滤斜杠/
    removeSlashes(str) {
      return str.replace(/\//g, '');
    },
    showPreview(item){
      ImagePreview({
        images: [item.attachment],
        closeable: true,
      });
    },
    onLoad() {
      setTimeout(() => {
        if(this.page1<this.totalPages1){
          this.page1 = this.page1+1;
        }
      },1000);
    },
    getListData(){
      this.loading1 = true;
      this.finished1 = false;
      if(this.searchParams.pageNum===1){
        this.inList = [];
      }
      this.$http.publicityManage(this.searchParams).then((res)=>{
        if(res){
          if(res.rows){
            this.loading1 = false;
            if(res.code===200){
              this.totals1 = res.total;
              this.totalPages1 = Math.ceil(res.total / this.size1);
              if (res.rows == null || res.rows.length === 0) {
                this.finished1 = true;
                this.inList = [];
                return false;
              } else {
                if (this.page1 > 1) {
                  this.inList = this.inList.concat(res.rows);
                } else {
                  this.inList = res.rows;
                }
                // 总条数和每页条数
                if (this.totals1 < this.size1) {
                  this.finished1 = true;
                  return;
                }
                // 当前页和总页数
                if (this.page1 === this.totalPages1) {
                  this.finished1 = true;
                  return false;
                }
              }
            }else{
              this.$toast.fail(res.msg);
            }
          }
        }
      });
    },
  },
  created() {
    this.getListData();
  }
}
</script>

<template>
  <div class="sun-warp">
    <div class="sun-header">
      <div class="sun-title">西藏福彩阳光公示</div>
      <div class="sun-text">透明公正，阳光福彩</div>
    </div>
    <div class="sun-content">
      <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt" :immediate-check="false" @load="onLoad">
        <div class="notice-item" v-for="(item,index) in inList" :key="index" :class="item.state==='1'?'highlight':''">
          <div class="notice-header">
            <div class="status-badge" :class="item.state==='2'?'status-active':'status-expired'">
              {{ item.state==='1'?'公示中':'' }}
              {{ item.state==='2'?'公示完成':'' }}
            </div>
            <div class="notice-title" >
              {{item.publicTitle}}
            </div>
          </div>
          <div class="notice-meta">
            <div class="notice-date">类型：{{item.changetype}}</div>
          </div>
          <div class="notice-meta">
            <div class="notice-date">姓名：{{item.name}}</div>
          </div>
          <div class="notice-meta">
            <div class="notice-date">手机号：{{item.phone}}</div>
          </div>
          <div class="notice-meta">
            <div class="notice-date">网点编号：{{item.siteid}}</div>
          </div>
          <div class="notice-meta">
            <div class="notice-date">地址：{{removeSlashes(item.address)}}</div>
          </div>
          <div class="notice-meta">
            <div class="notice-date">
              📅 公示时间：{{ item.startTime }}
            </div>
            <div class="view-detail-btn" v-if="item.attachment" @click="showPreview(item)">
              查看详情
            </div>
            <van-image
                style="display: none"
                width="100"
                height="10"
                :src="item.attachment"
                @click="showPreview(item)"
            />
          </div>
        </div>
      </van-list>
    </div>
  </div>
  <!--  <div class="sun-warp">-->
  <!--    <div class="sun-header">-->
  <!--      <div class="sun-title">西藏福彩阳光公示</div>-->
  <!--      <div class="sun-text">透明公正，阳光福彩</div>-->
  <!--    </div>-->
  <!--    <div class="sun-content">-->
  <!--      <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt" :immediate-check="false" @load="onLoad">-->
  <!--      <div class="notice-item" v-for="(item,index) in inList" :key="index" :class="index===0?'highlight':''">-->
  <!--        <div class="notice-header">-->
  <!--          <div class="notice-title" >-->
  <!--            {{item.publicTitle}}-->
  <!--          </div>-->
  <!--          <div class="status-badge" :class="item.state==='2'?'status-active':'status-expired'">-->
  <!--            {{ item.state==='1'?'未开始':'' }}-->
  <!--            {{ item.state==='2'?'公示中':'' }}-->
  <!--            {{ item.state==='3'?'公示完成':'' }}-->
  <!--          </div>-->
  <!--        </div>-->
  <!--        <div class="notice-meta">-->
  <!--          <div class="notice-date">-->
  <!--            📅 公示时间：{{ item.startTime }}-->
  <!--          </div>-->
  <!--          <button class="view-detail-btn" @click="showPreview(item)">-->
  <!--            查看详情-->
  <!--          </button>-->
  <!--          <van-image-->
  <!--              style="display: none"-->
  <!--              width="100"-->
  <!--              height="10"-->
  <!--              :src="item.attachment"-->
  <!--              @click="showPreview(item)"-->
  <!--          />-->
  <!--        </div>-->
  <!--      </div>-->
  <!--      </van-list>-->
  <!--    </div>-->
  <!--  </div>-->
</template>
<style scoped lang="scss">
.sun-warp{
  position: relative;
  left: 0;
  top: 0;
  font-size: 28px;
  height: 100vh;
  //width: 100vw;
  //overflow-y: auto;
  overflow: hidden;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px 16px;

}
.sun-header{
  height: 180px;
  display: flex;
  flex-direction: column;
  color: #fff;
  .sun-title{
    display: flex;
    justify-content: center;
    font-size: 38px;
    font-weight: bold;
    padding: 30px 0 20px;
  }
  .sun-text{
    display: flex;
    justify-content: center;
    font-size: 26px;
  }
}
.sun-content{
  background: #fff;
  border-radius: 20px;
  height: 80%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  .notice-item:nth-child(1){
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  .notice-item{
    display: flex;
    flex-direction: column;
    padding: 20px 25px;
    border-bottom: 1px solid #f0f0f0;
    transition: all 0.3s ease;
    .notice-header{
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 22px;
      .notice-title{
        flex: 1;
        font-weight: 500;
        color: #333;
        line-height: 1.4;
        margin-left: 12px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .status-badge{
        padding: 4px 22px;
        border-radius: 50px;
        font-weight: 500;
        white-space: nowrap;
        flex-shrink: 0;
        font-size: 22px;
      }
      .status-active{
        background: linear-gradient(135deg, #4CAF50, #45a049);
        color: white;
        box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
      }
      .status-expired{
        background: linear-gradient(135deg, #ff6b6b, #ee5a52);
        color: white;
        box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);}
    }
    .notice-meta{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;
      .notice-date{
        color: #666;
        font-size: 24px;
      }
      .view-detail-btn{
        background: linear-gradient(135deg, #667eea, #764ba2);
        color: white;
        border: none;
        padding: 14px 34px;
        border-radius: 50px;
        cursor: pointer;
        font-size: 24px;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
      }
    }
  }
  .highlight{
    background: linear-gradient(135deg, #fff3cd, #ffeaa7);
    border-left: 4px solid #f39c12;
  }
}
</style>